const trimTrailingSlash = (value) => value.replace(/\/+$/, '');

const getDefaultApiBaseUrl = () => {
  if (typeof window === 'undefined') {
    return 'http://localhost:8000/api';
  }

  const { origin, hostname } = window.location;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000/api';
  }

  return `${origin}/api`;
};

const API_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_API_URL || getDefaultApiBaseUrl()
);

export default API_BASE_URL;
